// Уровни смелости сочетаний: 🟢 classic / 🟡 interesting / 🔴 bold.
// В книге «Тезаурус вкусов» формальных уровней нет — они выведены из тона
// авторских эссе Ники Сегнит (классика/традиция → classic, одобряемое
// небанальное → interesting, рискованное/спорное → bold) и могут быть
// скорректированы кондитерами: правьте значение пары прямо в этой карте.
//
// Ключ пары — два slug-а через '__', отсортированные по алфавиту (сочетание
// симметрично). Хелпер pairKey ниже гарантирует одинаковый ключ для
// «яблоко × корица» и «корица × яблоко».

export type FlavorLevel = 'classic' | 'interesting' | 'bold'

/** Метки уровней: 🟢 Классика / 🟡 Интересно / 🔴 Смело. */
export const LEVEL_META: Record<FlavorLevel, { label: string; emoji: string }> = {
  classic: { label: 'Классика', emoji: '🟢' },
  interesting: { label: 'Интересно', emoji: '🟡' },
  bold: { label: 'Смело', emoji: '🔴' },
}

/** Канонический ключ пары из двух slug-ов (симметричный). */
export const pairKey = (a: string, b: string): string =>
  [a, b].sort().join('__')

/** Уровни всех пар графа (349 сочетаний, выведены из эссе книги). */
export const FLAVOR_LEVELS: Record<string, FlavorLevel> = {
  'abrikos__apelsin': 'classic', // Абрикос + Апельсин
  'abrikos__imbir': 'interesting', // Абрикос + Имбирь
  'abrikos__kardamon': 'classic', // Абрикос + Кардамон
  'abrikos__korica': 'classic', // Абрикос + Корица
  'abrikos__malina': 'classic', // Абрикос + Малина
  'abrikos__mango': 'interesting', // Абрикос + Манго
  'abrikos__mindal': 'classic', // Абрикос + Миндаль
  'abrikos__persik': 'interesting', // Абрикос + Персик
  'abrikos__roza': 'interesting', // Абрикос + Роза
  'abrikos__rozmarin': 'interesting', // Абрикос + Розмарин
  'abrikos__shokolad': 'classic', // Абрикос + Шоколад
  'abrikos__vanil': 'classic', // Абрикос + Ваниль
  'ananas__anis': 'interesting', // Ананас + Анис
  'ananas__apelsin': 'classic', // Ананас + Апельсин
  'ananas__banan': 'interesting', // Ананас + Банан
  'ananas__belyy-shokolad': 'interesting', // Ананас + Белый шоколад
  'ananas__chili': 'interesting', // Ананас + Чили
  'ananas__greypfrut': 'classic', // Ананас + Грейпфрут
  'ananas__klubnika': 'classic', // Ананас + Клубника
  'ananas__kokos': 'classic', // Ананас + Кокос
  'ananas__korica': 'interesting', // Ананас + Корица
  'ananas__malina': 'classic', // Ананас + Малина
  'ananas__mango': 'interesting', // Ананас + Манго
  'ananas__shalfey': 'bold', // Ананас + Шалфей
  'ananas__shokolad': 'bold', // Ананас + Шоколад
  'ananas__vanil': 'classic', // Ананас + Ваниль
  'ananas__vinograd': 'interesting', // Ананас + Виноград
  'ananas__yabloko': 'interesting', // Ананас + Яблоко
  'anis__apelsin': 'interesting', // Анис + Апельсин
  'anis__banan': 'interesting', // Анис + Банан
  'anis__bazilik': 'interesting', // Анис + Базилик
  'anis__chernaya-smorodina': 'interesting', // Анис + Черная смородина
  'anis__dynya': 'interesting', // Анис + Дыня
  'anis__greckiy-oreh': 'interesting', // Анис + Грецкий орех
  'anis__grusha': 'interesting', // Анис + Груша
  'anis__inzhir': 'interesting', // Анис + Инжир
  'anis__klubnika': 'interesting', // Анис + Клубника
  'anis__kokos': 'interesting', // Анис + Кокос
  'anis__korica': 'classic', // Анис + Корица
  'anis__limon': 'interesting', // Анис + Лимон
  'anis__mindal': 'classic', // Анис + Миндаль
  'anis__morkov': 'interesting', // Анис + Морковь
  'anis__shokolad': 'bold', // Анис + Шоколад
  'anis__vanil': 'interesting', // Анис + Ваниль
  'anis__vinograd': 'interesting', // Анис + Виноград
  'anis__yabloko': 'classic', // Анис + Яблоко
  'apelsin__chili': 'interesting', // Апельсин + Чили
  'apelsin__dynya': 'interesting', // Апельсин + Дыня
  'apelsin__greckiy-oreh': 'classic', // Апельсин + Грецкий орех
  'apelsin__greypfrut': 'interesting', // Апельсин + Грейпфрут
  'apelsin__gvozdika': 'classic', // Апельсин + Гвоздика
  'apelsin__imbir': 'classic', // Апельсин + Имбирь
  'apelsin__inzhir': 'classic', // Апельсин + Инжир
  'apelsin__klubnika': 'classic', // Апельсин + Клубника
  'apelsin__kofe': 'interesting', // Апельсин + Кофе
  'apelsin__korica': 'classic', // Апельсин + Корица
  'apelsin__laym': 'classic', // Апельсин + Лайм
  'apelsin__limon': 'classic', // Апельсин + Лимон
  'apelsin__mango': 'bold', // Апельсин + Манго
  'apelsin__mindal': 'classic', // Апельсин + Миндаль
  'apelsin__morkov': 'interesting', // Апельсин + Морковь
  'apelsin__mozhzhevelnik': 'interesting', // Апельсин + Можжевельник
  'apelsin__myata': 'bold', // Апельсин + Мята
  'apelsin__persik': 'interesting', // Апельсин + Персик
  'apelsin__reven': 'bold', // Апельсин + Ревень
  'apelsin__roza': 'classic', // Апельсин + Роза
  'apelsin__rozmarin': 'interesting', // Апельсин + Розмарин
  'apelsin__semena-koriandra': 'interesting', // Апельсин + Семена кориандра
  'apelsin__shafran': 'classic', // Апельсин + Шафран
  'apelsin__shokolad': 'classic', // Апельсин + Шоколад
  'apelsin__svekla': 'interesting', // Апельсин + Свекла
  'apelsin__timyan': 'interesting', // Апельсин + Тимьян
  'apelsin__vanil': 'classic', // Апельсин + Ваниль
  'apelsin__yabloko': 'interesting', // Апельсин + Яблоко
  'arahis__banan': 'classic', // Арахис + Банан
  'arahis__chernaya-smorodina': 'interesting', // Арахис + Черная смородина
  'arahis__chili': 'classic', // Арахис + Чили
  'arahis__kokos': 'classic', // Арахис + Кокос
  'arahis__korica': 'interesting', // Арахис + Корица
  'arahis__laym': 'classic', // Арахис + Лайм
  'arahis__morkov': 'interesting', // Арахис + Морковь
  'arahis__myata': 'bold', // Арахис + Мята
  'arahis__shokolad': 'classic', // Арахис + Шоколад
  'arahis__tomaty': 'classic', // Арахис + Томаты
  'arahis__vanil': 'interesting', // Арахис + Ваниль
  'arahis__vinograd': 'classic', // Арахис + Виноград
  'arahis__yabloko': 'classic', // Арахис + Яблоко
  'arbuz__chili': 'interesting', // Арбуз + Чили
  'arbuz__dynya': 'classic', // Арбуз + Дыня
  'arbuz__korica': 'interesting', // Арбуз + Корица
  'arbuz__laym': 'classic', // Арбуз + Лайм
  'arbuz__myata': 'interesting', // Арбуз + Мята
  'arbuz__rozmarin': 'bold', // Арбуз + Розмарин
  'arbuz__shokolad': 'interesting', // Арбуз + Шоколад
  'arbuz__tomaty': 'interesting', // Арбуз + Томаты
  'banan__funduk': 'interesting', // Банан + Фундук
  'banan__greckiy-oreh': 'classic', // Банан + Грецкий орех
  'banan__grusha': 'interesting', // Банан + Груша
  'banan__kardamon': 'interesting', // Банан + Кардамон
  'banan__kofe': 'classic', // Банан + Кофе
  'banan__kokos': 'classic', // Банан + Кокос
  'banan__korica': 'classic', // Банан + Корица
  'banan__mindal': 'classic', // Банан + Миндаль
  'banan__shokolad': 'classic', // Банан + Шоколад
  'banan__vanil': 'classic', // Банан + Ваниль
  'banan__vishnya': 'interesting', // Банан + Вишня
  'bazilik__greckiy-oreh': 'interesting', // Базилик + Грецкий орех
  'bazilik__gvozdika': 'interesting', // Базилик + Гвоздика
  'bazilik__kokos': 'interesting', // Базилик + Кокос
  'bazilik__laym': 'interesting', // Базилик + Лайм
  'bazilik__limon': 'classic', // Базилик + Лимон
  'bazilik__malina': 'interesting', // Базилик + Малина
  'bazilik__myata': 'interesting', // Базилик + Мята
  'bazilik__slivochnyy-syr-maskarpone': 'classic', // Базилик + Сливочный сыр / маскарпоне
  'bazilik__tomaty': 'classic', // Базилик + Томаты
  'belyy-shokolad__ezhevika': 'interesting', // Белый шоколад + Ежевика
  'belyy-shokolad__kardamon': 'interesting', // Белый шоколад + Кардамон
  'belyy-shokolad__klubnika': 'interesting', // Белый шоколад + Клубника
  'belyy-shokolad__kofe': 'interesting', // Белый шоколад + Кофе
  'belyy-shokolad__kokos': 'bold', // Белый шоколад + Кокос
  'belyy-shokolad__limon': 'classic', // Белый шоколад + Лимон
  'belyy-shokolad__malina': 'classic', // Белый шоколад + Малина
  'belyy-shokolad__mindal': 'classic', // Белый шоколад + Миндаль
  'belyy-shokolad__shafran': 'interesting', // Белый шоколад + Шафран
  'belyy-shokolad__shokolad': 'bold', // Белый шоколад + Шоколад
  'chernaya-smorodina__kofe': 'interesting', // Черная смородина + Кофе
  'chernaya-smorodina__mindal': 'classic', // Черная смородина + Миндаль
  'chernaya-smorodina__mozhzhevelnik': 'interesting', // Черная смородина + Можжевельник
  'chernaya-smorodina__myata': 'interesting', // Черная смородина + Мята
  'chernaya-smorodina__shokolad': 'bold', // Черная смородина + Шоколад
  'chernaya-smorodina__slivochnyy-syr-maskarpone': 'classic', // Черная смородина + Сливочный сыр / маскарпоне
  'chernika__korica': 'classic', // Черника + Корица
  'chernika__limon': 'classic', // Черника + Лимон
  'chernika__mindal': 'interesting', // Черника + Миндаль
  'chernika__persik': 'classic', // Черника + Персик
  'chernika__semena-koriandra': 'interesting', // Черника + Семена кориандра
  'chernika__vanil': 'classic', // Черника + Ваниль
  'chernika__yabloko': 'interesting', // Черника + Яблоко
  'chili__greckiy-oreh': 'interesting', // Чили + Грецкий орех
  'chili__imbir': 'classic', // Чили + Имбирь
  'chili__kokos': 'classic', // Чили + Кокос
  'chili__limon': 'interesting', // Чили + Лимон
  'chili__mango': 'classic', // Чили + Манго
  'chili__mindal': 'classic', // Чили + Миндаль
  'chili__myata': 'classic', // Чили + Мята
  'chili__shokolad': 'interesting', // Чили + Шоколад
  'chili__tykva-batternat': 'interesting', // Чили + Тыква баттернат
  'dynya__imbir': 'bold', // Дыня + Имбирь
  'dynya__klubnika': 'bold', // Дыня + Клубника
  'dynya__mindal': 'bold', // Дыня + Миндаль
  'dynya__myata': 'classic', // Дыня + Мята
  'dynya__roza': 'interesting', // Дыня + Роза
  'dynya__vinograd': 'classic', // Дыня + Виноград
  'ezhevika__malina': 'classic', // Ежевика + Малина
  'ezhevika__mindal': 'interesting', // Ежевика + Миндаль
  'ezhevika__persik': 'classic', // Ежевика + Персик
  'ezhevika__vanil': 'classic', // Ежевика + Ваниль
  'ezhevika__yabloko': 'classic', // Ежевика + Яблоко
  'funduk__grusha': 'interesting', // Фундук + Груша
  'funduk__inzhir': 'interesting', // Фундук + Инжир
  'funduk__klubnika': 'interesting', // Фундук + Клубника
  'funduk__kofe': 'classic', // Фундук + Кофе
  'funduk__malina': 'classic', // Фундук + Малина
  'funduk__mindal': 'interesting', // Фундук + Миндаль
  'funduk__morkov': 'interesting', // Фундук + Морковь
  'funduk__rozmarin': 'interesting', // Фундук + Розмарин
  'funduk__shokolad': 'classic', // Фундук + Шоколад
  'funduk__vanil': 'classic', // Фундук + Ваниль
  'funduk__vishnya': 'interesting', // Фундук + Вишня
  'funduk__yabloko': 'interesting', // Фундук + Яблоко
  'greckiy-oreh__grusha': 'classic', // Грецкий орех + Груша
  'greckiy-oreh__inzhir': 'classic', // Грецкий орех + Инжир
  'greckiy-oreh__kofe': 'classic', // Грецкий орех + Кофе
  'greckiy-oreh__korica': 'classic', // Грецкий орех + Корица
  'greckiy-oreh__morkov': 'classic', // Грецкий орех + Морковь
  'greckiy-oreh__muskatnyy-oreh': 'classic', // Грецкий орех + Мускатный орех
  'greckiy-oreh__shokolad': 'classic', // Грецкий орех + Шоколад
  'greckiy-oreh__slivochnyy-syr-maskarpone': 'classic', // Грецкий орех + Сливочный сыр / маскарпоне
  'greckiy-oreh__svekla': 'interesting', // Грецкий орех + Свекла
  'greckiy-oreh__vanil': 'classic', // Грецкий орех + Ваниль
  'greckiy-oreh__vinograd': 'classic', // Грецкий орех + Виноград
  'greckiy-oreh__vishnya': 'classic', // Грецкий орех + Вишня
  'greckiy-oreh__yabloko': 'classic', // Грецкий орех + Яблоко
  'greypfrut__korica': 'interesting', // Грейпфрут + Корица
  'greypfrut__mozhzhevelnik': 'interesting', // Грейпфрут + Можжевельник
  'grusha__kardamon': 'interesting', // Груша + Кардамон
  'grusha__kashtany': 'interesting', // Груша + Каштаны
  'grusha__korica': 'classic', // Груша + Корица
  'grusha__mindal': 'classic', // Груша + Миндаль
  'grusha__shokolad': 'classic', // Груша + Шоколад
  'grusha__yabloko': 'classic', // Груша + Яблоко
  'gvozdika__imbir': 'classic', // Гвоздика + Имбирь
  'gvozdika__kofe': 'interesting', // Гвоздика + Кофе
  'gvozdika__korica': 'classic', // Гвоздика + Корица
  'gvozdika__persik': 'classic', // Гвоздика + Персик
  'gvozdika__tomaty': 'classic', // Гвоздика + Томаты
  'gvozdika__vanil': 'interesting', // Гвоздика + Ваниль
  'gvozdika__yabloko': 'interesting', // Гвоздика + Яблоко
  'imbir__kardamon': 'classic', // Имбирь + Кардамон
  'imbir__kofe': 'interesting', // Имбирь + Кофе
  'imbir__korica': 'classic', // Имбирь + Корица
  'imbir__laym': 'classic', // Имбирь + Лайм
  'imbir__limon': 'classic', // Имбирь + Лимон
  'imbir__mango': 'interesting', // Имбирь + Манго
  'imbir__mindal': 'classic', // Имбирь + Миндаль
  'imbir__myata': 'classic', // Имбирь + Мята
  'imbir__reven': 'bold', // Имбирь + Ревень
  'imbir__shokolad': 'classic', // Имбирь + Шоколад
  'imbir__tomaty': 'interesting', // Имбирь + Томаты
  'imbir__tykva-batternat': 'classic', // Имбирь + Тыква баттернат
  'imbir__vanil': 'interesting', // Имбирь + Ваниль
  'inzhir__korica': 'classic', // Инжир + Корица
  'inzhir__malina': 'interesting', // Инжир + Малина
  'inzhir__mindal': 'classic', // Инжир + Миндаль
  'inzhir__myata': 'interesting', // Инжир + Мята
  'inzhir__shokolad': 'interesting', // Инжир + Шоколад
  'inzhir__slivochnyy-syr-maskarpone': 'classic', // Инжир + Сливочный сыр / маскарпоне
  'inzhir__vanil': 'classic', // Инжир + Ваниль
  'kardamon__kofe': 'classic', // Кардамон + Кофе
  'kardamon__kokos': 'classic', // Кардамон + Кокос
  'kardamon__korica': 'classic', // Кардамон + Корица
  'kardamon__mango': 'classic', // Кардамон + Манго
  'kardamon__mindal': 'classic', // Кардамон + Миндаль
  'kardamon__morkov': 'classic', // Кардамон + Морковь
  'kardamon__roza': 'classic', // Кардамон + Роза
  'kardamon__semena-koriandra': 'interesting', // Кардамон + Семена кориандра
  'kardamon__shafran': 'classic', // Кардамон + Шафран
  'kardamon__shokolad': 'interesting', // Кардамон + Шоколад
  'kardamon__vanil': 'interesting', // Кардамон + Ваниль
  'kashtany__rozmarin': 'bold', // Каштаны + Розмарин
  'kashtany__shokolad': 'classic', // Каштаны + Шоколад
  'kashtany__tykva-batternat': 'interesting', // Каштаны + Тыква баттернат
  'kashtany__vanil': 'classic', // Каштаны + Ваниль
  'klubnika__kokos': 'interesting', // Клубника + Кокос
  'klubnika__korica': 'interesting', // Клубника + Корица
  'klubnika__malina': 'bold', // Клубника + Малина
  'klubnika__mindal': 'interesting', // Клубника + Миндаль
  'klubnika__myata': 'classic', // Клубника + Мята
  'klubnika__persik': 'classic', // Клубника + Персик
  'klubnika__reven': 'classic', // Клубника + Ревень
  'klubnika__shokolad': 'classic', // Клубника + Шоколад
  'klubnika__slivochnyy-syr-maskarpone': 'classic', // Клубника + Сливочный сыр / маскарпоне
  'klubnika__tomaty': 'bold', // Клубника + Томаты
  'klubnika__vanil': 'classic', // Клубника + Ваниль
  'klubnika__vinograd': 'interesting', // Клубника + Виноград
  'kofe__korica': 'classic', // Кофе + Корица
  'kofe__mindal': 'classic', // Кофе + Миндаль
  'kofe__roza': 'bold', // Кофе + Роза
  'kofe__semena-koriandra': 'interesting', // Кофе + Семена кориандра
  'kofe__shokolad': 'classic', // Кофе + Шоколад
  'kofe__vanil': 'classic', // Кофе + Ваниль
  'kofe__vishnya': 'classic', // Кофе + Вишня
  'kokos__korica': 'classic', // Кокос + Корица
  'kokos__laym': 'classic', // Кокос + Лайм
  'kokos__limon': 'interesting', // Кокос + Лимон
  'kokos__malina': 'classic', // Кокос + Малина
  'kokos__mango': 'classic', // Кокос + Манго
  'kokos__mindal': 'interesting', // Кокос + Миндаль
  'kokos__morkov': 'interesting', // Кокос + Морковь
  'kokos__shokolad': 'interesting', // Кокос + Шоколад
  'kokos__svekla': 'interesting', // Кокос + Свекла
  'kokos__vanil': 'classic', // Кокос + Ваниль
  'kokos__vishnya': 'interesting', // Кокос + Вишня
  'korica__laym': 'classic', // Корица + Лайм
  'korica__mindal': 'classic', // Корица + Миндаль
  'korica__morkov': 'classic', // Корица + Морковь
  'korica__myata': 'interesting', // Корица + Мята
  'korica__shokolad': 'classic', // Корица + Шоколад
  'korica__slivochnyy-syr-maskarpone': 'classic', // Корица + Сливочный сыр / маскарпоне
  'korica__timyan': 'interesting', // Корица + Тимьян
  'korica__tomaty': 'interesting', // Корица + Томаты
  'korica__tykva-batternat': 'classic', // Корица + Тыква баттернат
  'korica__vishnya': 'classic', // Корица + Вишня
  'korica__yabloko': 'classic', // Корица + Яблоко
  'laym__limon': 'interesting', // Лайм + Лимон
  'laym__mango': 'classic', // Лайм + Манго
  'laym__myata': 'classic', // Лайм + Мята
  'laym__shokolad': 'interesting', // Лайм + Шоколад
  'laym__tomaty': 'classic', // Лайм + Томаты
  'laym__tykva-batternat': 'interesting', // Лайм + Тыква баттернат
  'limon__mindal': 'classic', // Лимон + Миндаль
  'limon__mozhzhevelnik': 'classic', // Лимон + Можжевельник
  'limon__myata': 'classic', // Лимон + Мята
  'limon__roza': 'classic', // Лимон + Роза
  'limon__rozmarin': 'interesting', // Лимон + Розмарин
  'limon__semena-koriandra': 'classic', // Лимон + Семена кориандра
  'limon__shafran': 'classic', // Лимон + Шафран
  'limon__shokolad': 'bold', // Лимон + Шоколад
  'limon__timyan': 'classic', // Лимон + Тимьян
  'limon__tomaty': 'classic', // Лимон + Томаты
  'malina__mindal': 'classic', // Малина + Миндаль
  'malina__myata': 'interesting', // Малина + Мята
  'malina__persik': 'classic', // Малина + Персик
  'malina__shokolad': 'classic', // Малина + Шоколад
  'malina__vanil': 'classic', // Малина + Ваниль
  'mango__myata': 'interesting', // Манго + Мята
  'mango__persik': 'interesting', // Манго + Персик
  'mango__reven': 'interesting', // Манго + Ревень
  'mango__yabloko': 'interesting', // Манго + Яблоко
  'mindal__persik': 'classic', // Миндаль + Персик
  'mindal__reven': 'interesting', // Миндаль + Ревень
  'mindal__roza': 'classic', // Миндаль + Роза
  'mindal__rozmarin': 'interesting', // Миндаль + Розмарин
  'mindal__shafran': 'interesting', // Миндаль + Шафран
  'mindal__shokolad': 'classic', // Миндаль + Шоколад
  'mindal__tykva-batternat': 'classic', // Миндаль + Тыква баттернат
  'mindal__vinograd': 'interesting', // Миндаль + Виноград
  'mindal__vishnya': 'classic', // Миндаль + Вишня
  'mindal__yabloko': 'classic', // Миндаль + Яблоко
  'morkov__yabloko': 'classic', // Морковь + Яблоко
  'mozhzhevelnik__reven': 'bold', // Можжевельник + Ревень
  'mozhzhevelnik__shalfey': 'interesting', // Можжевельник + Шалфей
  'muskatnyy-oreh__shafran': 'classic', // Мускатный орех + Шафран
  'muskatnyy-oreh__shokolad': 'interesting', // Мускатный орех + Шоколад
  'muskatnyy-oreh__tomaty': 'classic', // Мускатный орех + Томаты
  'muskatnyy-oreh__tykva-batternat': 'classic', // Мускатный орех + Тыква баттернат
  'muskatnyy-oreh__vanil': 'classic', // Мускатный орех + Ваниль
  'muskatnyy-oreh__yabloko': 'classic', // Мускатный орех + Яблоко
  'myata__shokolad': 'classic', // Мята + Шоколад
  'persik__vanil': 'classic', // Персик + Ваниль
  'persik__vinograd': 'classic', // Персик + Виноград
  'persik__vishnya': 'interesting', // Персик + Вишня
  'reven__rozmarin': 'interesting', // Ревень + Розмарин
  'reven__shafran': 'bold', // Ревень + Шафран
  'reven__vanil': 'classic', // Ревень + Ваниль
  'roza__shafran': 'classic', // Роза + Шафран
  'roza__shokolad': 'classic', // Роза + Шоколад
  'roza__yabloko': 'interesting', // Роза + Яблоко
  'rozmarin__shokolad': 'interesting', // Розмарин + Шоколад
  'rozmarin__tykva-batternat': 'interesting', // Розмарин + Тыква баттернат
  'rozmarin__vinograd': 'interesting', // Розмарин + Виноград
  'semena-koriandra__yabloko': 'interesting', // Семена кориандра + Яблоко
  'anis__chili': 'interesting', // Анис + Чили
  'anis__shafran': 'interesting', // Анис + Шафран
  'anis__tomaty': 'bold', // Анис + Томаты
  'chili__tomaty': 'classic', // Чили + Томаты
  'slivochnyy-syr-maskarpone__tomaty': 'classic', // Сливочный сыр / маскарпоне + Томаты
  'shalfey__tomaty': 'classic', // Шалфей + Томаты
  'shalfey__tykva-batternat': 'classic', // Шалфей + Тыква баттернат
  'shalfey__yabloko': 'interesting', // Шалфей + Яблоко
  'shokolad__svekla': 'bold', // Шоколад + Свекла
  'shokolad__timyan': 'interesting', // Шоколад + Тимьян
  'shokolad__tomaty': 'bold', // Шоколад + Томаты
  'shokolad__vanil': 'classic', // Шоколад + Ваниль
  'shokolad__vishnya': 'classic', // Шоколад + Вишня
  'slivochnyy-syr-maskarpone__vinograd': 'classic', // Сливочный сыр / маскарпоне + Виноград
  'slivochnyy-syr-maskarpone__yabloko': 'classic', // Сливочный сыр / маскарпоне + Яблоко
  'svekla__yabloko': 'interesting', // Свекла + Яблоко
  'timyan__tomaty': 'classic', // Тимьян + Томаты
  'tomaty__vanil': 'bold', // Томаты + Ваниль
  'tykva-batternat__yabloko': 'interesting', // Тыква баттернат + Яблоко
  'vanil__vishnya': 'classic', // Ваниль + Вишня
  'vanil__yabloko': 'classic', // Ваниль + Яблоко
}

/** Уровень пары или null, если ещё не размечена. */
export const getPairLevel = (a: string, b: string): FlavorLevel | null =>
  FLAVOR_LEVELS[pairKey(a, b)] ?? null
